import { urlDecode } from './urlEncodeDecode';

export const urlConvertKeyValue = (value: string) => 
  // console.log(JSON.parse(urlDecode(value).replace("111_", '')))
   String(urlDecode(value))
    .replace(/_/, '⁂')
    .split('⁂')
    ?.map(item => (item && item?.includes('{') && item?.includes('}') ? JSON.parse(item) || '' : item))
;
